<template>
    <div>
        <div class="col-12 header" v-bind:class="{ searching: isSearching }">
            <i class="fa fa-bars pull-left" aria-hidden="true"></i>

            <label> {{ title }} </label>

            <i
                    class="fa fa-search pull-right action-item"
                    aria-hidden="true"
                    v-if="canSearch"
                    @click="isSearching = !isSearching"
            ></i>
            
            <slot name="template-listing-header">
            </slot>

            <input
                    v-bind:placeholder="resource('TemplateListingBase_SearchValue_PlaceHolder')"
                    type="text"
                    class="form-control"
                    v-if="isSearching"
                    v-model="searchValue"
            />
        </div>

        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <label> {{ listTitle }} </label>
                </div>
            </div>

            <div class="row template-listing" 
                 v-for="template in displayedTemplates"
                 @click="templateSelected(template)"
                 v-bind:key="template.Id"
                 v-bind:class="{ 'selected': selectedTemplate === template }"
            >
                <slot name="template-listing-item" v-bind:template="template"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import resourceMixin from '../../../../Util/Mixins/resources';
    import templateApi from '../../../../Api/template-manager';
    
    import funcRepo from '../../Util/functionRepository';
    
    const SELECTION_EVENT_NAME = 'TEMPLATE-LISTING-SELECTION';
    
    export default {
        name: "template-listing",
        mixins: [resourceMixin],
        computed: {
            displayedTemplates(){
                const vm = this;
                
                //Take all templates without a parent
                // let templates = vm.templates.filter(t => !t.ParentId);
                let templates = vm.templates;
                
                
                if(vm.searchValue){
                    //Convert to lowercase for 'case-insensitive' comparison
                    const searchValue = vm.searchValue.toLowerCase();

                    //Take only templates matching our search
                    templates = templates.filter(t =>
                        t.Name && t.Name.toLowerCase().indexOf(searchValue) !== -1
                    );
                }

                //Sort our templates by last modified
                templates = templates.sort((left, right) => {
                    //Take the dates
                    const dateLeft = left.Modified;
                    const dateRight = right.Modified;

                    if(dateRight > dateLeft) return 1;
                    if(dateLeft > dateRight) return -1;
                    
                    return 0;
                });
                
                return templates;
            }
        },
        beforeCreate(){
            const vm = this;
            
            //Deselect our current template on execute
            vm.subscriptionId = funcRepo.subscribe(
                () => vm.selectedTemplate = null, 
                SELECTION_EVENT_NAME
            );
        },
        destroyed(){
            const vm = this;
            
            funcRepo.unsubscribe(vm.subscriptionId);
        },
        methods: {
            templateSelected(template){
                const vm = this;
                
                //Deselect all templates => select our selected template
                funcRepo.executeAsync(SELECTION_EVENT_NAME)
                    .then(() => vm.selectedTemplate = template);
            }
        },
        watch: {
            isSearching(value){
                const vm = this;

                //Reset searchValue
                if(!value){
                    vm.searchValue = null;
                }
            }
        },
        data(){
            return {
                isSearching: false,
                searchValue: null,
                selectedTemplate: null,
                subscriptionId: null
            }
        },
        props: {
            title: {
                type: String,
                required: true
            },
            canSearch: {
                type: Boolean,
                required: false,
                default: false
            },
            listTitle: {
                type: String,
                required: true
            },
            templates: {
                type: Array,
                required: true,
                default(){
                    return {
                        Id: '',
                        Name: '',
                        Modified: new Date()
                    }
                }
            }
        }
    };
</script>

<style scoped src="../../Style/template-listing-base.scss" lang="scss">
</style>
